import template from './stChosenFilter.template.html';

export default {
  template,
  bindings: {
    filterName: '<',
    isReady: '<',
    onRemoved: '&'
  },
controller: class controller {
    constructor() {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;

      ctrl.initialize = () => {
        ctrl.filterName = ctrl.filterName || 'N/A';
        ctrl.isReady = ctrl.isReady || false;
      };

      ctrl.filterRemove = () => {
        ctrl.onRemoved();
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
